<template>
    <CCardHeader>
        <slot />
    </CCardHeader>
</template>

<script setup>
import { CCardHeader } from '@coreui/vue-pro'
</script>

<style scoped>

</style>
